import type { OrgAdminGateStatus } from '@/hooks/useOrgAdminRenderGate';
import AuthCheckFailed from '@components/AuthCheckFailed';
import { FullLoading } from '@components/Loaders';
import React from 'react';

export interface RouteAccessGateProps {
  /** The non-'authorized' branch of useOrgAdminRenderGate's status. */
  status: Exclude<OrgAdminGateStatus, 'authorized'>;
  pendingLabel: string;
  deniedLabel: string;
}

/** Renders the fallback for useOrgAdminRenderGate's non-authorized states — typically once
 *  `status !== 'authorized'`, though AuthPage also remaps an authorized-but-still-loading render
 *  onto it. Extracted from InstrumentsPage's POR-485 fix; see git history (issue #396). */
export default function RouteAccessGate({ status, pendingLabel, deniedLabel }: RouteAccessGateProps) {
  if (status === 'auth-error') return <AuthCheckFailed />;
  // Callers deliberately pass neutral copy as `deniedLabel`: `denied` awaits useRouteProtection's
  // own redirect and `unauthenticated` the root beforeLoad's /login, so naming either outcome
  // would flash a rejection the user is about to be navigated away from anyway.
  return <FullLoading label={status === 'pending' ? pendingLabel : deniedLabel} />;
}
